module.exports = __webpack_public_path__ + "static/media/milk.aafc64e1.svg";